import React from 'react';

import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';

import { useCommon, useUser } from '@hooks';
import { ConfirmationModal } from '@components';
import Roles from '../../components/RolesCarusel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const UserInviteRoles = () => {
  const { t } = useTranslation();
  const { state: userInviteData } = useLocation();
  const history = useHistory();
  const { setModal } = useCommon();
  const { inviteUser } = useUser();

  if (!userInviteData) {
    history.push('/configuration-users-invite-form');
  }

  const handleClick = (role) => {
    inviteUser({ ...userInviteData, roles: role });
  };

  const handleRoleConfirm = (role) => {
    const {
      first_name: firstName,
      patern_last: paternalLastName,
      matern_last: maternalLastName,
    } = userInviteData;
    const userName = `${firstName} ${paternalLastName}${
      maternalLastName && ` ${maternalLastName}`
    }`;
    setModal({
      body: (
        <ConfirmationModal
          htmlIdCancelButton="cancel-create-invitation-collaborator"
          htmlIdConfirmButton="confirm-create-invitation-collaborator"
          title={t('Onboarding.MerchantOnboarding.confirmModal.colaboratorMessage', {
            userName,
          })}
          handleConfirm={() => {
            handleClick(role);
          }}
        />
      ),
    });
  };

  return <Roles handleClick={handleRoleConfirm} prevSelection={userInviteData.roles} />;
};

export default UserInviteRoles;
